var answersArr = []

$(document).ready(function () {
  checkURL()

  // start
  $(".start .cta").on("click tap", function () {
    // find parent, then sibling, hide it
    $(
      ".start .cta",
    )[0].parentElement.parentElement.parentElement.nextElementSibling.classList.remove(
      "hide",
    )

    $(".start").addClass("animating-out")
    $(".start").on("transitionend", function () {
      $(".start").toggleClass("hide")
      initQuestion(document.querySelector(".quiz-question"), 0)
    })
  })
  // next button
  $(".quiz-question__submit").on("click tap", function () {
    // primary parent element
    var parentElem = $(this)[0].parentElement.parentElement
    // last quiz question
    var lastQuestion = $(".quiz-question").last()[0].className
    // data value of selected choice
    var selectedChoice = $(".quiz-question__input.selected").attr("data-key")
    if (parentElem.classList.value === lastQuestion) {
      // if above is last question
      // answersArr.push(selectedChoice);
      parentElem.classList.add("hide")
    }
  })
})

function showForm() {
  var overlay = document.querySelector(".quiz-overlay--gate")
  overlay.classList.remove("hide")
}

function initQuestion(parent, currentQuestion) {
  var form = parent.querySelector(".quiz-question__form")
  var button = form.querySelector("button")
  var formRatingText = form.querySelector(".quiz-question__rating-label")
  var formRatings = form.querySelector(".quiz-question__ratings")
  var ratingSelected = false
  var ratingSelectedInput = null
  var allLabels = form.querySelectorAll("label")
  var allInputs = form.querySelectorAll("input")
  var factoids = document.querySelectorAll(".factoid")
  var progressBar = parent.querySelector(".quiz-question__progress-bar")
  var className = "step-"
  var factoidAnimated = false
  var factoidHasBeenViewed = false

  // hide the texture separator that is above the factoids
  document.querySelector(".quiz-factoid-separator").classList.add("hide")

  setTimeout(function () {
    form.focus()
  }, 1)

  currentQuestion = currentQuestion + 1

  // hide the factoid that is currently displayed
  if (currentQuestion > 1) {
    factoids[currentQuestion - 2].classList.add("hide")
  }

  className = "step-" + currentQuestion
  progressBar.classList.add(className, "step-animation")

  button.setAttribute("disabled", "disabled")
  parent.classList.add("animating-in")

  if (currentQuestion === 12) {
    button.textContent = "Get results"
  }

  var factoidElement = factoids[currentQuestion - 1]

  form.addEventListener("change", e => {
    e.preventDefault()
    if (e.target.value === "-2") {
      formRatingText.textContent = "Strongly disagree"
    } else if (e.target.value === "-1") {
      formRatingText.textContent = "Disagree"
    } else if (e.target.value === "0") {
      formRatingText.textContent = "Neither agree nor disagree"
    } else if (e.target.value === "1") {
      formRatingText.textContent = "Agree"
    } else if (e.target.value === "2") {
      formRatingText.textContent = "Strongly agree"
    }

    ratingSelected = true
    ratingSelectedInput = e.target

    button.removeAttribute("disabled")

    if (!factoidAnimated) {
      factoidElement.classList.remove("hide")
      document.querySelector(".quiz-factoid-separator").classList.remove("hide")

      if (currentQuestion <= 3) {
        let observer = new IntersectionObserver((element, observer) => {
          if (element[0].intersectionRatio <= 0.5 && !factoidHasBeenViewed) {
            $("html, body").animate(
              {
                scrollTop: $(factoidElement).offset().top,
              },
              1000,
            )
            factoidHasBeenViewed = true
            observer.unobserve(element[0].target)
          }
        })
        observer.observe(factoidElement)
      }
    }
  })

  form.addEventListener("submit", e => {
    e.preventDefault()

    answersArr.push(form.elements.rating.value)

    if (parent.nextElementSibling.classList.contains("quiz-question")) {
      parent.nextElementSibling.classList.remove("hide")

      parent.classList.add("animating-out")
      factoids[currentQuestion - 1].classList.add("animating-out")

      setTimeout(function () {
        parent.classList.add("hide")
        initQuestion(parent.nextElementSibling, currentQuestion)
        $("html, body").animate(
          {
            scrollTop: 0,
          },
          1000,
        )
      }, 500)
    } else {
      parent.classList.add("hide")
      setTimeout(function () {
        scroller(document.querySelector(".scroll-down__button"))
      }, 500)
      document.querySelector(".quiz-factoid-separator").classList.add("hide")
      factoids[currentQuestion - 1].classList.add("hide")
      //showResults();
      document.querySelector(".quiz-learn-questions").classList.remove("hide")
      showForm()
      showResults()
      showContactUs()
    }
  })

  formRatings.addEventListener("mouseover", e => {
    if (
      e.target.tagName === "LABEL" ||
      e.target.parentElement.tagName === "LABEL"
    ) {
      var el

      if (e.target.tagName === "LABEL") {
        el = e.target
      } else {
        el = e.target.parentElement
      }

      focusLabel(el)
    } else {
      formRatingText.textContent = "Select one"
      formRatingText.classList = "quiz-question__rating-label"
    }
  })

  allInputs.forEach(input => {
    input.addEventListener("focus", e => {
      changeText(input.nextElementSibling)
    })

    if (input.checked) {
      applyChoice(input)
      changeText(input.nextElementSibling)
    }
  })

  function changeText(element) {
    formRatingText.textContent = element.textContent
    formRatingText.classList =
      "color--" + element.dataset.valueText + " quiz-question__rating-label"
  }

  function focusLabel(el) {
    changeText(el)

    if (ratingSelected) {
      // find all labels after the selected one and when hovering one of those, add class to the hovered one and all between hovered and checked
      var labels = form.querySelectorAll(
        ".quiz-question__ratings input:checked ~ label",
      )

      for (var i = 0; i < labels.length; i++) {
        if (labels[i] != el) {
          labels[i].classList.add("hovering")
        } else {
          labels[i].classList.add("hovering")
          break
        }
      }
    }
  }

  function blurLabel() {
    formRatings.classList.remove("hovering")

    if (!ratingSelected) {
      formRatingText.textContent = "Select one"
      formRatingText.classList = "quiz-question__rating-label"
    } else {
      for (var i = 0; i < allLabels.length; i++) {
        allLabels[i].classList.remove("hovering")
        formRatingText.textContent = ratingSelectedInput.dataset.valueText
        formRatingText.classList =
          "quiz-question__rating-label color--" +
          ratingSelectedInput.dataset.valueText.replace(/ /g, "-")
      }
    }
  }

  formRatings.addEventListener("mouseout", e => {
    blurLabel()
  })

  function applyChoice(element) {
    if (element.value === "-2") {
      formRatingText.textContent = "Strongly disagree"
    } else if (element.value === "-1") {
      formRatingText.textContent = "Disagree"
    } else if (element.value === "1") {
      formRatingText.textContent = "Agree"
    } else if (element.value === "2") {
      formRatingText.textContent = "Strongly agree"
    }

    ratingSelected = true
    ratingSelectedInput = element

    button.removeAttribute("disabled")

    if (!factoidAnimated) {
      factoidElement.classList.remove("hide")
      document.querySelector(".quiz-factoid-separator").classList.remove("hide")
    }
  }
}

/* when navigating with the keyboard we want to style the choices a little differently, so add class to body */
window.addEventListener("keydown", function (e) {
  if (e.key === "Tab") {
    document.querySelector("body").classList.add("keyboard-navigation")
  }
})

/*
when using the mouse we want to remove the keyboard navigation style.
'click' event fires when the radio buttons are checked, so instead we are listening for the mousedown event in order to
remove the keyboard-navigation class
*/

window.addEventListener("mousedown", function (e) {
  document.querySelector("body").classList.remove("keyboard-navigation")
})

function closeOverlay() {
  document.querySelector(".quiz-overlay--contact").classList.add("hide")
}

function showContactUs() {
  document.querySelector(".product-book-a-demo").classList.remove("hide")

  bindContactUsLink()
}

function bindContactUsLink() {
  var link = document.querySelector(".product-book-a-demo a")
  var close = document.querySelector(
    ".quiz-overlay--contact .quiz-overlay__close",
  )
  var overlay = document.querySelector(".quiz-overlay--contact")

  link.addEventListener("click", function (e) {
    e.preventDefault()

    overlay.classList.remove("hide")
  })

  close.addEventListener("click", closeOverlay)
  window.addEventListener("keyup", windowKeyUpHandler)
}

function windowKeyUpHandler(e) {
  if (e.key === "Escape") {
    closeOverlay()
  }
}

function getResultsElement(element) {
  var sibling = element.nextElementSibling

  while (sibling) {
    if (sibling.classList.contains("hide")) {
      sibling = sibling.nextElementSibling
    } else {
      return sibling
    }
  }
}

function scroller(scrollButton) {
  scrollButton.closest(".scroll-down").classList.remove("hide")

  scrollButton.addEventListener("click", function () {
    var targetEl = getResultsElement(scrollButton.closest(".scroll-down"))
    var offset = targetEl.getBoundingClientRect().top
    var headerHeight = document
      .querySelector(".globalNav")
      .getBoundingClientRect().height

    window.scrollTo({
      top: parseInt(offset + window.pageYOffset - headerHeight, 10),
      left: 0,
      behavior: "smooth",
    })
  })
}

function tallyUp(answers) {
  return answers.reduce(function (accumulator, currentValue) {
    return parseInt(accumulator) + parseInt(currentValue)
  })
}

function posNeg(tarNum) {
  if (Math.sign(tarNum) < 1) {
    return "negative"
  } else {
    return "positive"
  }
}

function showResults(results) {
  results = answersArr

  var positive = "positive"
  var negative = "negative"
  var mx1_One = posNeg(results[0])
  var mx1_Two = posNeg(results[1])
  var resultsTally = []
  var matrix2Results = []
  // for building email share link
  var baseURL = "https://www.cultureamp.com/performance-web-quiz"
  /*
    Matrix 1 Logic take first two items 0,1 in array, put under matrix 1 logic (results-one one, results-one two, results-one three, results-one four)
    */
  if (mx1_One === positive && mx1_Two === positive) {
    $(".results-one.one").removeClass("hide")
    var resultsOne = "_results-one_one"
  } else if (mx1_One === negative && mx1_Two === positive) {
    $(".results-one.two").removeClass("hide")
    var resultsOne = "_results-one_two"
  } else if (mx1_One === positive && mx1_Two === negative) {
    $(".results-one.three").removeClass("hide")
    var resultsOne = "_results-one_three"
  } else if (mx1_One === negative && mx1_Two === negative) {
    $(".results-one.four").removeClass("hide")
    var resultsOne = "_results-one_four"
  }
  // fair process 3
  resultsTally.push(results[2], results[3], results[4])
  mx2Prep(resultsTally)
  // aligned goals 2
  resultsTally.push(results[5], results[6])
  mx2Prep(resultsTally)
  // feedback dev 3
  resultsTally.push(results[7], results[8], results[9])
  mx2Prep(resultsTally)
  // accountrecog 2
  resultsTally.push(results[10], results[11])
  mx2Prep(resultsTally)

  function mx2Prep(target) {
    matrix2Results.push(posNeg(tallyUp(target)))
    resultsTally.length = 0
  }
  var mx2_One = matrix2Results[0]
  var mx2_Two = matrix2Results[1]
  var mx2_Three = matrix2Results[2]
  var mx2_Four = matrix2Results[3]
  /*
    Matrix 2 Logic
      .results-two.one : all negative
      .results-two.two : positive negative x 3
      .results-two.three : positive x2 negative x2
      .results-two.four : positive x3 negative
      .results-two.five : all positive
      .results-two.six : negative positive x3
      .results-two.seven : negative x2 positive x2
      .results-two.eight : negative x3 positive
      .results-two.nine : negative positive x2 negative
      .results-two.ten : positive negative x2 positive
      .results-two.eleven : positive negative positive x2
      .results-two.twelve : positive x2 negative positive
      .results-two.thirteen : negative positive negative x2
      .results-two.fourteen : negative x2 positive negative
      .results-two.fifteen : negative positive negative positive
      .results-two.sixteen : positive negative positive negative
    */
  if (
    mx2_One === negative &&
    mx2_Two === negative &&
    mx2_Three === negative &&
    mx2_Four === negative
  ) {
    $(".results-two.one").removeClass("hide")
    var resultsTwo = "_results-two_one"
  } else if (
    mx2_One === positive &&
    mx2_Two === negative &&
    mx2_Three === negative &&
    mx2_Four === negative
  ) {
    $(".results-two.two").removeClass("hide")
    var resultsTwo = "_results-two_two"
  } else if (
    mx2_One === positive &&
    mx2_Two === positive &&
    mx2_Three === negative &&
    mx2_Four === negative
  ) {
    $(".results-two.three").removeClass("hide")
    var resultsTwo = "_results-two_three"
  } else if (
    mx2_One === positive &&
    mx2_Two === positive &&
    mx2_Three === positive &&
    mx2_Four === negative
  ) {
    $(".results-two.four").removeClass("hide")
    var resultsTwo = "_results-two_four"
  } else if (
    mx2_One === positive &&
    mx2_Two === positive &&
    mx2_Three === positive &&
    mx2_Four === positive
  ) {
    $(".results-two.five").removeClass("hide")
    var resultsTwo = "_results-two_five"
  } else if (
    mx2_One === negative &&
    mx2_Two === positive &&
    mx2_Three === positive &&
    mx2_Four === positive
  ) {
    $(".results-two.six").removeClass("hide")
    var resultsTwo = "_results-two_six"
  } else if (
    mx2_One === negative &&
    mx2_Two === negative &&
    mx2_Three === positive &&
    mx2_Four === positive
  ) {
    $(".results-two.seven").removeClass("hide")
    var resultsTwo = "_results-two_seven"
  } else if (
    mx2_One === negative &&
    mx2_Two === negative &&
    mx2_Three === negative &&
    mx2_Four === positive
  ) {
    $(".results-two.eight").removeClass("hide")
    var resultsTwo = "_results-two_eight"
  } else if (
    mx2_One === negative &&
    mx2_Two === positive &&
    mx2_Three === positive &&
    mx2_Four === negative
  ) {
    $(".results-two.nine").removeClass("hide")
    var resultsTwo = "_results-two_nine"
  } else if (
    mx2_One === positive &&
    mx2_Two === negative &&
    mx2_Three === negative &&
    mx2_Four === positive
  ) {
    $(".results-two.ten").removeClass("hide")
    var resultsTwo = "_results-two_ten"
  } else if (
    mx2_One === positive &&
    mx2_Two === negative &&
    mx2_Three === positive &&
    mx2_Four === positive
  ) {
    $(".results-two.eleven").removeClass("hide")
    var resultsTwo = "_results-two_eleven"
  } else if (
    mx2_One === positive &&
    mx2_Two === positive &&
    mx2_Three === negative &&
    mx2_Four === positive
  ) {
    $(".results-two.twelve").removeClass("hide")
    var resultsTwo = "_results-two_twelve"
  } else if (
    mx2_One === negative &&
    mx2_Two === positive &&
    mx2_Three === negative &&
    mx2_Four === negative
  ) {
    $(".results-two.thirteen").removeClass("hide")
    var resultsTwo = "_results-two_thirteen"
  } else if (
    mx2_One === negative &&
    mx2_Two === negative &&
    mx2_Three === positive &&
    mx2_Four === negative
  ) {
    $(".results-two.fourteen").removeClass("hide")
    var resultsTwo = "_results-two_fourteen"
  } else if (
    mx2_One === negative &&
    mx2_Two === positive &&
    mx2_Three === negative &&
    mx2_Four === positive
  ) {
    $(".results-two.fifteen").removeClass("hide")
    var resultsTwo = "_results-two_fifteen"
  } else if (
    mx2_One === positive &&
    mx2_Two === negative &&
    mx2_Three === positive &&
    mx2_Four === negative
  ) {
    $(".results-two.sixteen").removeClass("hide")
    var resultsTwo = "_results-two_sixteen"
  }
  // build URL for email sharing
  var shareURL = baseURL + "?one=" + resultsOne + "&two=" + resultsTwo
  $('.hs-input[name="last_personalized_url"]').val(shareURL).change()
}

function checkURL() {
  // check for query strings, if present, match up and show/hide the Results.
  if (
    decodeURIComponent(getUrlParameter("one")) &&
    decodeURIComponent(getUrlParameter("two"))
  ) {
    // check results one
    var setOne = decodeURIComponent(getUrlParameter("one")).replace(/_/g, ".")
    // check results two
    var setTwo = decodeURIComponent(getUrlParameter("two")).replace(/_/g, ".")
    $(".start").toggleClass("hide")
    $(setOne + "," + setTwo).removeClass("hide")
    $(".quiz-learn-questions").removeClass("hide")
    $(".product-book-a-demo").removeClass("hide")
    $(".blur").removeClass("blur")
  }
}

function getUrlParameter(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]")
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)")
  var results = regex.exec(location.search)
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "))
}
